import { defineMessages, useIntl } from "react-intl";
import { IconLanguageOff } from "@tabler/icons-react";
import Skeleton from "react-loading-skeleton";
import { classNames, TranslatedString } from "@ct-react/core";
import { SkeletonableProps } from "../../tools/components";
import InfoBox from "../common/info-box";
import "./description.scss";

const transDefs = defineMessages({
  empty: { id: "article.description-empty", defaultMessage: "Il n'y a aucune description pour ce bien." },
  language: { id: "article.description-language", defaultMessage: "Cette information n'est pas disponible dans votre langue." }
});

type Props = SkeletonableProps<TranslatedString> & { displayLoading?: boolean };

const DescriptionPart = ({ className, loading, displayLoading = false, data }: Props) => {

  const intl = useIntl();

  const wrapperClasses = classNames("description-part", className);

  if (loading && displayLoading)
    return (
      <div className={wrapperClasses}>
        <Skeleton count={6} />
        <Skeleton width="25%" />
        <br />
        <Skeleton count={4} />
        <Skeleton width="65%" />
        <br />
        <Skeleton count={7} />
        <Skeleton width="40%" />
      </div>);

  return (
    <div className={wrapperClasses}>
      {!data
        ? <InfoBox formatting="for-language"
                   icon={<IconLanguageOff />}
                   msg={intl.formatMessage(transDefs.empty)}
                   inline={true} />
        : <>
            {!data.matchLang &&
              <InfoBox formatting="for-language"
                       icon={<IconLanguageOff />}
                       msg={intl.formatMessage(transDefs.language)}
                       inline={true} />
            }
            <div className="html-format" dangerouslySetInnerHTML={{ __html: data.value }} />
          </>
      }
    </div>);

}


export default DescriptionPart;
